import { render, staticRenderFns } from "./bind-public-number.vue?vue&type=template&id=e8b76844&scoped=true&"
import script from "./bind-public-number.vue?vue&type=script&lang=js&"
export * from "./bind-public-number.vue?vue&type=script&lang=js&"
import style0 from "./bind-public-number.vue?vue&type=style&index=0&id=e8b76844&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8b76844",
  null
  
)

export default component.exports